export const COLORS = [
  "#FF0000",
  "#00FF00",
  "#0000FF",
  "#FFFF00",
  "#FF00FF",
  "#00FFFF",
  "#800000",
  "#808000",
  "#008000",
  "#800080",
  "#008080",
  "#000080",
  "#FF4500",
  "#32CD32",
  "#8A2BE2",
  "#FFD700",
  "#DC143C",
  "#1E90FF",
  "#FF1493",
  "#00CED1",
  "#FF6347",
  "#2E8B57",
  "#DAA520",
  "#4B0082",
  "#8B4513",
  "#9ACD32",
  "#D2691E",
  "#20B2AA",
  "#FF69B4",
  "#B22222",
  "#5F9EA0",
  "#D8BFD8",
  "#ADFF2F",
  "#FF8C00",
  "#9932CC",
  "#FFB6C1",
  "#6A5ACD",
  "#7CFC00",
  "#BA55D3",
  "#CD5C5C",
  "#8B0000",
  "#556B2F",
  "#7B68EE",
  "#DDA0DD",
  "#B0E0E6",
  "#FF00FF",
  "#3CB371",
  "#FA8072",
  "#00FA9A",
  "#FFDAB9",
  "#E6E6FA",
  "#1E90FF",
  "#9370DB",
  "#7FFFD4",
  "#DB7093",
  "#F0E68C",
  "#48D1CC",
  "#C71585",
  "#FFA07A",
  "#20B2AA",
  "#B0C4DE",
  "#F08080",
  "#E0FFFF",
  "#FAEBD7",
  "#A52A2A",
  "#F4A460",
  "#00BFFF",
  "#008B8B",
  "#D2B48C",
  "#4169E1",
  "#8FBC8F",
  "#B8860B",
  "#4682B4",
  "#6B8E23",
  "#708090",
  "#9ACD32",
  "#6495ED",
  "#FFDEAD",
  "#FF4500",
  "#F5F5DC",
  "#2F4F4F",
  "#7FFF00",
  "#8B008B",
  "#F5DEB3",
  "#8A2BE2",
  "#FFD700",
  "#D2691E",
  "#FF69B4",
  "#CD853F",
  "#FA8072",
  "#BC8F8F",
  "#66CDAA",
  "#DEB887",
  "#FF00FF",
  "#00FF7F",
  "#DC143C",
  "#ADFF2F",
  "#FFA500",
  "#8B0000",
  "#BDB76B",
];
